import { transformEnumToDisplay } from '@fruitful/member-profile';
import { InvestmentType } from '@fruitful/types';
import type { ColumnEditorOptions } from 'primereact/column';
import type { MultiSelectChangeEvent } from 'primereact/multiselect';

import {
    MultiSelectEditor,
    type MultiSelectOption,
} from '../../../common/components/GridCellEditors';

export const InvestmentsEditor = (options: ColumnEditorOptions) => {
    const investments = Object.values(InvestmentType).map((investment) => ({
        label: transformEnumToDisplay(investment),
        value: investment,
    }));

    return (
        <MultiSelectEditor
            options={options}
            multiSelectProps={{
                options: investments,
                placeholder: 'Select Investments',
                onChange: (e: MultiSelectChangeEvent) => {
                    // Handle "None" case

                    // If None is selected, clear all other values.
                    if (
                        (e.selectedOption as MultiSelectOption).value ===
                            (InvestmentType.NONE as string) &&
                        (e.value as string[]).includes(InvestmentType.NONE)
                    ) {
                        e.value = [InvestmentType.NONE];
                    }

                    // If a non-None option is selected, unselect None.
                    if (
                        (e.selectedOption as MultiSelectOption).value !==
                            (InvestmentType.NONE as string) &&
                        (e.value as string[]).includes(InvestmentType.NONE)
                    ) {
                        e.value = (e.value as string[]).filter(
                            (option) =>
                                option !== (InvestmentType.NONE as string),
                        );
                    }

                    options.editorCallback?.(e.value ?? null);
                },
            }}
        />
    );
};
